import { err } from "./result";
export class PasswordValidator {
    constructor() {
        this.minLength = 8;
        this.minUpperCase = 1;
        this.minLowerCase = 1;
        this.minDigits = 1;
        this.minSpecialChars = 1;
        this.specialCharsRegex = /[!@#$%^&*()\-_=+[\]{}|;:'",.<>?/\\ ]/;
    }
    validate(newPassword, reEnteredNewPassword, currentPassword = null, newPasswordHashed = null, currentPasswordHashed = null, passwordConfiguration = null) {
        var _a;
        const passwordLength = (_a = passwordConfiguration === null || passwordConfiguration === void 0 ? void 0 : passwordConfiguration.minPasswordLength) !== null && _a !== void 0 ? _a : this.minLength;
        if (reEnteredNewPassword && newPassword !== reEnteredNewPassword) {
            return err("PASSWORD_MISMATCH");
        }
        if (newPasswordHashed && currentPasswordHashed && currentPasswordHashed === newPasswordHashed) {
            return err("OLD_PASSWORD_REUSED");
        }
        if (currentPassword && currentPassword === newPassword) {
            return err("OLD_PASSWORD_REUSED");
        }
        if (newPassword.length < passwordLength) {
            return err("PASSWORD_CRITERIA_MISMATCH");
        }
        const upperCaseCount = this.countUpperCaseLetters(newPassword);
        if (upperCaseCount < this.minUpperCase) {
            return err("PASSWORD_CRITERIA_MISMATCH");
        }
        const lowerCaseCount = this.countLowerCaseLetters(newPassword);
        if (lowerCaseCount < this.minLowerCase) {
            return err("PASSWORD_CRITERIA_MISMATCH");
        }
        const digitCount = this.countDigits(newPassword);
        if (digitCount < this.minDigits) {
            return err("PASSWORD_CRITERIA_MISMATCH");
        }
        const specialCharCount = this.countSpecialChars(newPassword);
        if (specialCharCount < this.minSpecialChars) {
            return err("PASSWORD_CRITERIA_MISMATCH");
        }
        return true;
    }
    validateMultipleErrors(fields) {
        var _a;
        const { newPassword, reEnteredNewPassword, currentPassword, newPasswordHashed, currentPasswordHashed, passwordConfiguration } = fields;
        const passwordLength = (_a = passwordConfiguration === null || passwordConfiguration === void 0 ? void 0 : passwordConfiguration.minPasswordLength) !== null && _a !== void 0 ? _a : this.minLength;
        const errors = [];
        if (reEnteredNewPassword && newPassword !== reEnteredNewPassword) {
            errors.push("PASSWORD_MISMATCH");
        }
        if (newPasswordHashed && currentPasswordHashed && currentPasswordHashed === newPasswordHashed) {
            errors.push("OLD_PASSWORD_REUSED");
        }
        if (currentPassword && currentPassword === newPassword) {
            errors.push("OLD_PASSWORD_REUSED");
        }
        if (newPassword.length < passwordLength) {
            errors.push("PASSWORD_CRITERIA_MISMATCH");
        }
        const upperCaseCount = this.countUpperCaseLetters(newPassword);
        if (upperCaseCount < this.minUpperCase) {
            errors.push("PASSWORD_CRITERIA_MISMATCH");
        }
        const lowerCaseCount = this.countLowerCaseLetters(newPassword);
        if (lowerCaseCount < this.minLowerCase) {
            errors.push("PASSWORD_CRITERIA_MISMATCH");
        }
        const digitCount = this.countDigits(newPassword);
        if (digitCount < this.minDigits) {
            errors.push("PASSWORD_CRITERIA_MISMATCH");
        }
        const specialCharCount = this.countSpecialChars(newPassword);
        if (specialCharCount < this.minSpecialChars) {
            errors.push("PASSWORD_CRITERIA_MISMATCH");
        }
        return errors;
    }
    countUpperCaseLetters(password) {
        return password.replace(/[^A-Z]/g, "").length;
    }
    countLowerCaseLetters(password) {
        return password.replace(/[^a-z]/g, "").length;
    }
    countDigits(password) {
        return password.replace(/\D/g, "").length;
    }
    countSpecialChars(password) {
        var _a;
        return ((_a = password.match(this.specialCharsRegex)) !== null && _a !== void 0 ? _a : []).length;
    }
}
